<template>
  <div id="app">
    <van-config-provider>
      <nav-bar />
      <router-view v-slot="{ Component }">
        <section class="app-wrapper">
          <keep-alive :include="keepAliveRouteNames">
            <component :is="Component" />
          </keep-alive>
          <tab-bar />
        </section>
      </router-view>
    </van-config-provider>

    <!-- 维护公告 -->
    <MaintainPopup ref="MaintainPopupRef" />

    <!-- 账户在其他设备登录提示 -->
    <LembretePopup ref="LembretePopupRef" />

    <!-- 提现公告 -->
    <TopUpPopup ref="TopUpPopupRef" />

    <!-- 图片公告 -->
    <ImagesPopup ref="ImagesPopupRef" />

    <!-- 活动公告 -->
    <AtividadePopup ref="AtividadePopupRef" />

    <!-- 咨询公告 -->
    <SiteMessagePopup ref="SiteMessagePopupRef" />

    <!-- 注册成功贺语弹窗 -->
    <RegistrGreetingsPopup
      ref="RegistrGreetingsRef"
      @manual-close="handleGetImagesList"
      @download="handleGetImagesList"
      @deposite="handleDepositoPopupOpen"
    />

    <!-- 登录注册弹窗 -->
    <LoginRegisterPopup ref="LoginRegisterRef" @close="handlePopupOpen" />

    <!-- 充值弹窗 -->
    <Deposito ref="DepositoPopupRef" @close="handleGetImagesList" />

    <!-- 浮动视频 -->
    <!-- <van-floating-bubble
      v-if="route.name != 'Games'"
      v-model:offset="offset"
      class="floating-view"
      @click="handleLivePopupOpen"
    >
      <img :src="getImageUrlWithCDN_TEST('/live.avif')" />
    </van-floating-bubble> -->

    <!-- <LivePopup ref="LivePopupRef" /> -->
  </div>
</template>

<script setup>
import { STORAGE_LANG_KEY, STORAGE_TOKEN_KEY, STORAGE_USER_INFO_KEY } from '@/stores/mutation-type'
import { bindAccountOwnershipApi } from '@/api/profile/userInfo'
import { useRouteCacheStore } from '@/stores'
import { useI18n } from 'vue-i18n'
import { initWebSocket } from './utils/websocketService'
import { useWebSocketStore } from '@/stores/websocketStore'
import { useEventBus } from '@vueuse/core'
import pinia from '@/stores'
import { useRouter } from 'vue-router'
import { closeWebSocket } from '@/utils/websocketService'
import { claimJoinLoginApi } from '@/api/activity/index'
import { useUserStore } from '@/stores'

const router = useRouter()
const route = useRoute()
const { t } = useI18n()
const actiTimer = ref(null) // 活动接口定时器
const AtividadeImagesPopupChecked = ref(window.localStorage.AtividadeImagesPopupChecked || 'null')
const LoginRegisterRef = ref(null) //  登录注册弹窗
const openLoginPopup = useEventBus('open-login-popup')
const refreshHomeEventBus = useEventBus('refreshHomeInfo')

/**
 * 账户在其他设备登录提示相关
 */
const MaintainPopupRef = ref(null)
const handleMaintainPopupOpen = () => {
  nextTick(() => {
    MaintainPopupRef.value.open()
  })
}

/**
 * 账户在其他设备登录提示相关
 */
const LembretePopupRef = ref(null)
const handleLembretePopupOpen = () => {
  nextTick(() => {
    LembretePopupRef.value.open()
  })
}

/**
 * 提现公告弹窗相关
 */
const TopUpPopupRef = ref(null)
const handleTopUpPopupOpen = (msg) => {
  nextTick(() => {
    TopUpPopupRef.value.open(msg)
  })
}

/**
 * 图片公告弹窗相关
 */
const ImagesPopupRef = ref(null)
const handleImagesPopupOpen = () => {
  nextTick(() => {
    ImagesPopupRef.value.open()
  })
}
const handleGetImagesList = () => {
  nextTick(() => {
    ImagesPopupRef.value.getList()
  })
}

/**
 * 活动公告弹窗相关
 */
const AtividadePopupRef = ref(null)
const handleAtividadePopupOpen = () => {
  nextTick(() => {
    AtividadePopupRef.value.open()
  })
}
const handleGetAtividadeList = () => {
  nextTick(() => {
    AtividadePopupRef.value.getList()
  })
}

/**
 * 咨询公告弹窗相关
 */
const SiteMessagePopupRef = ref(null)
const handleSiteMessagePopupOpen = () => {
  nextTick(() => {
    SiteMessagePopupRef.value.open()
  })
}
const handleGetSiteMessageList = () => {
  nextTick(() => {
    SiteMessagePopupRef.value.getList()
  })
}

/**
 * 注册成功贺语弹窗相关
 */
const RegistrGreetingsRef = ref(null)
const handleRegistrGreetingsPopupOpen = () => {
  nextTick(() => {
    RegistrGreetingsRef.value.open()
    localStorage.setItem('is_register_success_greetings_show', 'hidden')
  })
}
refreshHomeEventBus.on(handleRegistrGreetingsPopupOpen)

/**
 * 充值弹窗相关
 */
const DepositoPopupRef = ref(null)
const handleDepositoPopupOpen = () => {
  nextTick(() => {
    DepositoPopupRef.value.openPopupDeposit()
  })
}

const handlePopupOpen = () => {
  if (hadToken.value) {
    const isRegisterSuccessGreetingsShow =
      localStorage.getItem('is_register_success_greetings_show') || 'hidden'
    if (isRegisterSuccessGreetingsShow === 'hidden') {
      handleGetImagesList()
    }
  } else {
    handleGetAtividadeList()
  }
}

// 添加监听器
const handleOpenLoginPopup = () => {
  nextTick(() => {
    LoginRegisterRef.value.openPopupRegLogin()
  })
}
openLoginPopup.on(handleOpenLoginPopup)
const routeCacheStore = useRouteCacheStore()
const keepAliveRouteNames = computed(() => {
  return routeCacheStore.routeCaches
})
// 初始化 WebSocket
const websocketUrl = ref(null) // 替换为实际的 WebSocket URL JSON.parse(localStorage.getItem('initConfig')).ws_url
const userStore = useUserStore()
const hadToken = computed(() => {
  return !!userStore.userInfo.token
})

// 动态加载主题函数
function loadTheme() {}

function initWebSocketFun() {
  // 只有登录了才初始化 WebSocket
  if (hadToken.value) {
    websocketUrl.value = JSON.parse(localStorage.getItem('initConfig')).ws_url
    initWebSocket('wss://' + websocketUrl.value, async (message) => {
      // console.log('Received WebSocket message:', message)
      // 可以在这里触发全局事件或更新状态
      if (message.type == 'connected' && message?.client_id) {
        // clientId 绑定用户ID
        const clientId = message.client_id
        localStorage.setItem('clientId', clientId)
        // 直接调用useWebSocketStore的bindUser方法
        const websocketStore = useWebSocketStore(pinia)
        try {
          await websocketStore.bindUser(clientId)
          // console.log('main ts clientId bound to WebSocket connection:', clientId)
        } catch (error) {
          console.error('main ts  Failed to bind clientId to WebSocket:', error)
        }
      }

      if (message.type == 'mailReceive' && message?.body) {
        // 如果用户在邮件页面，则广播通知邮件页面插入数据，如果不在邮件页面需要全局弹窗提示吗
        const currentRoute = router.currentRoute.value.name
        if (currentRoute === 'Mail') {
          // 发送事件通知邮件页面
          const mailEventBus = useEventBus('mail-received')
          mailEventBus.emit(message.body)
        } else {
          // 显示全局通知
          const notificationEventBus = useEventBus('global-notification')
          notificationEventBus.emit({
            type: 'mail',
            message: message.body.title || 'Você recebeu um novo e-mail',
          })
        }
      }

      if (message.type == 'home_top' && message?.body) {
        showNotify({
          type: 'primary',
          message: message.body.title + ' : ' + message.body.content || '-----',
        })
      }

      // 系统维护时
      if (message.type == 'maintain' && message?.body) {
        handleMaintainPopupOpen()
        return false
      }

      // 账号在其他设备登录时
      if (message.type == 'unbind' && message?.body) {
        handleLembretePopupOpen()
        return false
      }

      // 提现成功时
      if (message.type == 'withdraw' && message?.msg) {
        handleTopUpPopupOpen(message.msg)
        return false
      }

      // 当接受到站内消息时
      if (message.type == 'site_message' && message?.body) {
        nextTick(() => {
          handleGetSiteMessageList()
        })
      }
    })
  }
}
// 国际化
import { locale } from '@/utils/i18n'
const getLocale = () => {
  locale.value = localStorage.getItem(STORAGE_LANG_KEY) || 'pt-BR'
}

/**
 * 视频直播弹窗相关
 */
const offset = ref({ x: 0, y: 390 })

/**
 * 足球视频弹窗
 */

// const LivePopupRef = ref(null)
// const handleLivePopupOpen = () => {
//   nextTick(() => {
//     LivePopupRef.value.open()
//   })
// }

// 初始化
function initAppVue() {
  // 挂载完结束loadingbg的img
  document.querySelector('.loadingbg').style.display = 'none'

  // // 获取并存储邀请码
  // const urlParams = new URLSearchParams(window.location.search)
  // let inviteCode = urlParams.get('id') || ''
  // let channelId = urlParams.get('channel_id') || ''
  // let businessId = urlParams.get('business_id') || ''
  // // 分享链接功能模块
  // if (hadToken.value) {
  //   // 存在分享链接
  //   if (inviteCode || channelId || businessId) {
  //     localStorage.setItem('id', inviteCode || '')
  //     localStorage.setItem('channel_id', channelId || '')
  //     localStorage.setItem('business_id', businessId || '')
  //     // 直接用浏览器的信息 // console.log('上报分享信息-share-ids:', data)
  //   } else {
  //     // 存在分享链接  不处理  继续执上一个分享链接的参数
  //     // 直接用缓存的信息
  //     inviteCode = localStorage.getItem('id') || ''
  //     channelId = localStorage.getItem('channel_id') || ''
  //     businessId = localStorage.getItem('business_id') || ''
  //   }
  //   const sendShareIds = {
  //     id: inviteCode,
  //     channel_id: channelId,
  //     business_id: businessId,
  //   }
  //   // 上报分享信息
  //   try {
  //     await bindAccountOwnershipApi(sendShareIds)
  //   } catch (error) {
  //     //
  //   }
  // } else {
  //   if (inviteCode || channelId || businessId) {
  //     localStorage.setItem('id', inviteCode || '')
  //     localStorage.setItem('channel_id', channelId || '')
  //     localStorage.setItem('business_id', businessId || '')
  //   } else {
  //     // 如果不存在分享链接  不移除  继续执上一个分享链接的参数
  //     // localStorage.removeItem('id')
  //     // localStorage.removeItem('channel_id')
  //     // localStorage.removeItem('business_id')
  //   }
  // }

  // 获取并存储邀请码
  const urlParams = new URLSearchParams(window.location.search)
  const inviteCode = urlParams.get('id') || ''
  const channelId = urlParams.get('channel_id') || ''
  const businessId = urlParams.get('business_id') || ''
  if (inviteCode || channelId || businessId) {
    localStorage.setItem('id', inviteCode || '')
    localStorage.setItem('channel_id', channelId || '')
    localStorage.setItem('business_id', businessId || '')
  } else {
    // 如果不存在分享链接  不移除  继续执上一个分享链接的参数
    // localStorage.removeItem('id')
    // localStorage.removeItem('channel_id')
    // localStorage.removeItem('business_id')
  }

  getLocale()
  // 未登录主动弹出注册
  if (!hadToken.value) {
    nextTick(() => {
      LoginRegisterRef.value?.openPopupRegLogin('register')
    })
  }
  // nextTick(() => {
  //   LivePopupRef.value.open()
  // })
}

const senBindAccountOwnershipApi = async () => {
  const urlParams = new URLSearchParams(window.location.search)
  let inviteCode = urlParams.get('id') || ''
  let channelId = urlParams.get('channel_id') || ''
  let businessId = urlParams.get('business_id') || ''
  if (inviteCode || channelId || businessId) {
    localStorage.setItem('id', inviteCode || '')
    localStorage.setItem('channel_id', channelId || '')
    localStorage.setItem('business_id', businessId || '')
  } else {
    inviteCode = localStorage.getItem('id') || ''
    channelId = localStorage.getItem('channel_id') || ''
    businessId = localStorage.getItem('business_id') || ''
  }

  const sendShareIds = {
    id: inviteCode,
    channel_id: channelId,
    business_id: businessId,
  }
  // 上报分享信息
  await bindAccountOwnershipApi(sendShareIds)
}

// 监听登录状态变化，当登录时初始化WebSocket
watch(
  hadToken,
  (newToken) => {
    if (newToken) {
      senBindAccountOwnershipApi()
      initWebSocketFun()
    } else {
      // console.log('hadToken....')
      // nextTick(() => {
      //   LoginRegisterRef.value?.openPopupRegLogin('register')
      // })
    }
  },
  { immediate: true }
)

async function actiInitData() {
  // 是否有token
  if (!localStorage.getItem(STORAGE_TOKEN_KEY)) {
    showToast({
      message: 'Por favor, faça login primeiro.',
      wordBreak: 'break-word',
    })
    return
  }
  const { data, code, msg } = await claimJoinLoginApi()
  if (code == 1 && data.is_popup == 1) {
    successToast(msg || 'Solicitou com sucesso')
  }
}
onMounted(() => {
  initAppVue()
  const initConfig = JSON.parse(localStorage.getItem('localConfig'))
  const iconUrl = '/theme/skin_theme/favicon.ico'
  const iconUrlApple = '/theme/skin_theme/logo-pwa-192x192.png'
  useHead({
    title: () => initConfig.appName,
    meta: [
      {
        name: 'description',
        content: () => t('app.description'), // initConfig.appDescription
      },
    ],
    link: [
      {
        rel: 'icon',
        type: 'image/x-icon',
        href: iconUrl, // 动态设置
      },
      {
        rel: 'apple-touch-icon',
        href: iconUrlApple, // 动态设置 Apple Touch Icon
      },
    ],
  })

  //每十分钟调用一次
  actiTimer.value = setInterval(() => {
    actiInitData()
  }, 600000) // 10分
})

onUnmounted(() => {
  // 清理活动接口定时器
  if (actiTimer.value) {
    clearInterval(actiTimer.value)
  }
  openLoginPopup.off(handleOpenLoginPopup)
  refreshHomeEventBus.off(handleRegistrGreetingsPopupOpen)
})
</script>

<style scoped lang="scss">
.logo1-img {
  width: 234px;
  height: 70px;
}

.app-wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
}

/* 初始加载页面样式 */
.initial-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
